import Dexie, { type EntityTable } from 'dexie';
import type { Property } from '@/types';

// ============================================
// Typen
// ============================================

export interface CachedProperty {
  id: string;
  owner_id: string;
  data: Property; // vollständige Property inkl. financings, images, shares
  cached_at: number; // Unix ms timestamp
}

export interface SyncAction {
  id?: number; // auto-increment PK
  action: 'create' | 'update' | 'delete';
  record_id: string; // Property UUID (auch temporäre IDs bei offline-create)
  payload: Record<string, unknown>;
  queued_at: number; // Unix ms timestamp
}

// ============================================
// Dexie Datenbank
// ============================================

class FundamentDB extends Dexie {
  properties!: EntityTable<CachedProperty, 'id'>;
  sync_queue!: EntityTable<SyncAction, 'id'>;

  constructor() {
    super('fundament_offline');
    this.version(1).stores({
      properties: 'id, owner_id, cached_at',
      sync_queue: '++id, record_id, queued_at',
    });
  }
}

export const db = new FundamentDB();
